<template>
  <div class="page-wrapper">
    <div class="section-title">
      <div class="left">
        <i class="el-icon-shopping-cart-1"></i>
        <span class="title-name">途径管理</span>
      </div>
      <div class="right">
        <el-button @click="addSources" size="small" icon="el-icon-plus"
          >新增</el-button
        >
      </div>
    </div>
    <div class="project-table-wrapper comon-table-style">
      <el-table
        size="small"
        v-loading="tableLoading"
        :data="tableData"
        border
        class="table"
        style="width: 100%; border: 1px solid #dbdbdb"
        height="600"
      >
        <el-table-column
          prop="id"
          label="来源ID"
          align="center"
        ></el-table-column>
        <el-table-column prop="name" label="途径名称" align="center">
          <template slot-scope="scope">
            <span v-if="!scope.row.isEdit">{{ scope.row.name }}</span>
            <TableRowEdit v-if="scope.row.isEdit" v-model="scope.row.name" placeholder="请输入途径名称" @confirm="confirmEdit(scope.row)" @cancel="cancelEdit(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column prop="control" align="center" label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              v-if="!scope.row.isEdit"
              class="edit-btn"
              size="mini"
              @click="editSources(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              class="control-btn"
              size="mini"
              @click="deleteSources(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="pagenation-wrapper">
            <el-pagination
              class="pagenation"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSizes"
            ></el-pagination>
          </div>-->
    </div>
    <el-dialog
      title="新增途径"
      :visible.sync="dialogVisible"
      :center="false"
      width="500px"
    >
      <el-input
        v-model="newSourcesName"
        placeholder="请输入途径名称"
        style="width: 350px; margin: 0 auto"
        clearable
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmAddSources"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import commonMenu from "@/components/menu";
import qs from "qs";
import TableRowEdit from "@/components/TableRowEdit";
import { GetMerchantsSources } from "../api";
export default {
  name: "merchantSourcesList",
  components: {
    commonMenu,
    TableRowEdit
  },
  data() {
    return {
      newSourcesName: "",
      dialogVisible: false,
      tableLoading: false,
      tableData: [],
      totalSizes: 0,
      page: 0,
      size: 20,
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      this.tableLoading = true;
        GetMerchantsSources()
        .then((res) => {
          if (res.status === 200 || res.status === 206) {
            this.tableData = res.data.map((ele) => {
              return { id: ele.id, name: ele.name, isEdit: false };
            });
            // this.totalSizes = res.data.totalElements
            this.tableLoading = false;
          }
        })
        .catch((err) => {
          console.error("数据获取失败", err.response);
          this.$notify.error({
            title: "数据拉取错误",
            position: "bottom-right",
            duration: 1500,
            dangerouslyUseHTMLString: true,
            message: `<p>状态码：${err.response.data.status} </p>
                    <p>错误类型：${err.response.data.error} </p>
                    <p>错误信息：${err.response.data.message}</p>`,
          });
        });
    },
    addSources() {
      this.dialogVisible = true;
    },

    editSources(target) {
      target.isEdit = true;
    },
    confirmAddSources() {
      if (this.newSourcesName === "") {
        this.$message.error("新增来源名称不能为空");
        return false;
      }
      this.$api
        .post(`/merchants/sources`, {
          name: this.newSourcesName,
        })
        .then((res) => {
          if (res.status === 200 || res.status === 201) {
            this.$message.success("新增成功");
            this.dialogVisible = false;
            this.newSourcesName = "";
            this.getTableData();
          }
        })
        .catch((err) => {
          console.error("新增失败", err.response);
          this.$message.error("新增失败");
        });
    },
    confirmEdit(target) {
      this.$api
        .put(`/merchants/sources/${target.id}`, {
          id: target.id,
          name: target.name,
        })
        .then((res) => {
          if (res.status === 201 || res.status === 204) {
            this.$message.success("修改成功");
            this.getTableData();
          }
        })
        .catch((err) => {
          console.error("修改失败", err.response);
          this.$message.error("修改失败");
        });
    },
    cancelEdit(target) {
      target.isEdit = false;
      this.getTableData();
    },
    deleteSources(target) {
      this.$confirm(`是否确认删除 ${target.name} 吗？`, "提示", {
        confirmButtonText: "确认删除",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api
          .delete(`/merchants/sources/${target.id}`)
          .then((res) => {
            if (res.status === 204) {
              this.$message.success("删除成功");
              this.getTableData();
            }
          })
          .catch((err) => {
            console.error("数据获取失败", err.response);
            this.$message.error("删除失败");
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/custom-variables.scss";
.page-wrapper {
  .limit-winth {
    width: 100%;
    font-size: 14px;
    height: 18px;
    line-height: 18px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .table {
    border: 1px solid #dbdbdb;
  }
  .pagenation-wrapper {
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    line-height: 55px;
    text-align: left;
    background-color: transparent;
    padding: 0px 5px 0 5px;
    overflow: hidden;
    border: 1px solid #dbdbdb;
    border-top: none;
    .pagenation {
      padding: 0;
      margin-top: 10px;
    }
    .pagenation-samll {
      text-align: center;
    }
  }
  .section-title {
    width: 100%;
    padding: 19px 0 26px 0;
    border-bottom: 1px solid #e0e0e0;
    text-align: left;
    font-size: 24px;
    display: flex;
    justify-content: space-between;
    .left {
      flex: 1;
      text-align: left;
    }
    .right {
      flex: 1;
      text-align: right;
    }
    .title-name {
      font-size: 24px;
      color: #4a4a4a;
      font-weight: bold;
      margin-left: 8px;
    }
  }
  .table-tool-box {
    box-sizing: border-box;
    position: relative;
    // padding: 0 60px 0 0;
    margin-top: 30px;
    margin-bottom: 0;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    .tool-item {
      box-sizing: border-box;
      padding: 0 10px 0 0;
      flex: 1;
      display: flex;
      text-align: left;
      line-height: 40px;
      box-sizing: border-box;
      font-size: 0;
      &:last-child {
        padding: 0;
      }
      .tool-label {
        flex: 60px 0 0;
        width: 60px;
        text-align: left;
        font-size: 14px;
        font-weight: 450;
        color: #333;
        margin-right: 8px;
      }
      .tool-content {
        flex: 1;
        font-size: 14px;
        color: #333;
      }
    }
    .table-search {
      position: absolute;
      right: 0;
      bottom: 2px;
      width: 50px;
      height: 35px;
      line-height: 35px;
      font-size: 14px;
      text-align: center;
      color: #242424;
      border: 1px solid #929292;
      display: inline-block;
      transition: all 0.3s linear;
      &:hover {
        background-color: $theme_color;
        border: 1px solid $theme_color;
        color: #242424;
        cursor: pointer;
      }
    }
  }
}
</style>